import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/tesla/share.png'


const _withScopeId = n => (_pushScopeId("data-v-2c4887bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "pageShare-icon"
}, null, -1))
const _hoisted_3 = { class: "banner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "banner-tc" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-tc-divider" }, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "invite-agree" }
const _hoisted_9 = {
  key: 0,
  class: "invite-agree-checkbox"
}
const _hoisted_10 = {
  key: 0,
  class: "invite-btn"
}
const _hoisted_11 = {
  key: 1,
  class: "invite-wrapper"
}
const _hoisted_12 = { class: "invite-code" }
const _hoisted_13 = { class: "invite-code-label" }
const _hoisted_14 = { class: "invite-code-value" }
const _hoisted_15 = ["data-clipboard-text"]
const _hoisted_16 = { class: "invite-group" }
const _hoisted_17 = { class: "invite-btn" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "photo-icon" }, null, -1))
const _hoisted_19 = { class: "invite-btn" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "link-icon" }, null, -1))
const _hoisted_21 = { class: "guide" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "remark" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "share-inviteCode" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t_checkbox = _resolveComponent("t-checkbox")!
  const _component_my_button = _resolveComponent("my-button")!
  const _directive_stat = _resolveDirective("stat")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.shareVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "pageShare",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sharePage && _ctx.sharePage(...args)))
          }, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('分享')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.configInfo['banner-m1'],
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.previewContract(_ctx.configInfo.kfs))),
            class: "banner-tc-text"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('产品资料概要')), 1)
          ])), [
            [_directive_stat, { event: 'm1KeyFactsStatement', num: '1' }]
          ]),
          _hoisted_6,
          _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewContract(_ctx.configInfo.tc))),
            class: "banner-tc-text"
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('条款及细则')), 1)
          ])), [
            [_directive_stat, { event: 'm1TermsAndConditions', num: '1' }]
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["invite", { eng: _ctx.isEng }])
      }, [
        _createElementVNode("img", {
          class: "invite-bg",
          src: _ctx.configInfo['activity-m1'],
          alt: ""
        }, null, 8, _hoisted_7),
        _createElementVNode("div", {
          class: _normalizeClass(["invite-main", { hasCode: _ctx.inviteCode }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            (!_ctx.isSign && !_ctx.inviteCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("div", { class: "invite-agree-checkbox-tips" }, _toDisplayString(_ctx.$t('请先阅读并同意活动条款或细则1')), 513), [
                    [_vShow, _ctx.isShowAgreeTips]
                  ]),
                  _createVNode(_component_t_checkbox, {
                    modelValue: _ctx.isAgree,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isAgree) = $event)),
                    theme: "highlight"
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('本人已阅读并同意')), 1),
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkProto && _ctx.checkProto(...args)))
              }, _toDisplayString(_ctx.configInfo.contractName), 1),
              _createTextVNode(_toDisplayString(_ctx.$t('的条款及细则')), 1)
            ])
          ]),
          (!_ctx.inviteCode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_my_button, {
                  text: _ctx.$t('立即邀请好友'),
                  onClick: _ctx.handleClick
                }, null, 8, ["text", "onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('贷款邀请码')), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.inviteCode), 1),
                  _createElementVNode("i", {
                    class: "invite-code-copy",
                    "data-clipboard-text": _ctx.inviteCode,
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
                  }, null, 8, _hoisted_15)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_my_button, {
                      text: _ctx.$t('图片邀请'),
                      onClick: _ctx.handlePhoto,
                      size: "small"
                    }, {
                      before: _withCtx(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    }, 8, ["text", "onClick"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_my_button, {
                      text: _ctx.$t('链接邀请'),
                      onClick: _ctx.handleLink,
                      size: "small"
                    }, {
                      before: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["text", "onClick"])
                  ])
                ])
              ]))
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("img", {
          src: _ctx.configInfo['guide-m1'],
          alt: ""
        }, null, 8, _hoisted_22)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("img", {
          src: _ctx.configInfo['remark-m1'],
          alt: ""
        }, null, 8, _hoisted_24)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["share", { eng: _ctx.isEng }]),
      ref: "shareRef"
    }, [
      _createElementVNode("img", {
        src: _ctx.configInfo.sharePic,
        alt: "",
        class: "share-bg"
      }, null, 8, _hoisted_25),
      _createElementVNode("img", {
        src: _ctx.configInfo.sharePic2,
        alt: "",
        class: "share-bg2"
      }, null, 8, _hoisted_26),
      _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.inviteCode), 1)
    ], 2)
  ], 64))
}